






































import {
  Vue,
  Component,
} from "@/shared/vuepack";
import GenericLoadingSpinner from "@/shared/components/ui/GenericLoadingSpinner.vue";
import FileUpload from "vue-upload-component";
import { Validator } from "vee-validate";
import { formatDateTimeString } from "@/shared/dateString";
import { useNotifierStore } from "@/shared/store/notifier";
import { useStateMachineStore } from "@/admin/store/stateMachineStore";
import { StateMachineExecutionHistory } from "@/admin/types";
@Component({
  components: {
    FileUpload,
    GenericLoadingSpinner
  }
})
export default class StateMachineUtilityVue extends Vue {
  formatDateTimeString = formatDateTimeString;
  $validator: Validator;
  notifierStore = useNotifierStore();
  stateMachineStore = useStateMachineStore();
  created () {
    this.stateMachineStore.getMonitoredStateMachines(10);
  }
  get isLoading () {
    return !this.stateMachineStore.isLoaded;
  }
  get tableFields () {
    return this.stateMachineStore.executionHistories ? this.stateMachineStore.executionHistories : [];
  }

  listFields = [
    {
      key: "name",
      thClass: "text-left pl-2 col-md-6 col-6",
      tdClass: "pl-2 col-md-6 col-2",
      label: "Machine Name"
    },
    {
      key: "executionHistory",
      label: "History",
      thClass: "text-left",
      tdClass: "text-left col-6"
    }
  ];

  packageFields = [
    {
      key: "dateStarted",
      thClass: "text-left pl-2",
      tdClass: "pl-2 col-4",
      label: "Date Started"
    },
    {
      key: "dateStopped",
      label: "Date Stopped",
      thClass: "text-left",
      tdClass: "text-left col-4"
    },
    {
      key: "status",
      label: "Status",
      thClass: "text-left",
      tdClass: "text-left"
    }
  ];
}
